/**
 * Define a single validation test. Keep each test in its own file under tests/.
 * @param {string} id - Stable internal name
 * @param {string} name - User-friendly label
 * @param {import('./types').ValidationTestDefinition['run']} run
 * @returns {import('./types').ValidationTestDefinition}
 */
export function defineTest(id, name, run) {
  return { id, name, run };
}
